export enum Image {
    JPG = "image/jpg",
    JPEG = "image/jpeg",
    PNG = "image/png",
    GIF = "image/gif"
}
